export const PRINT_ROUTE_PREFIX = '/print/';
export const PRINT_ACTIVITIES_PATH = '/print/activities';
// The one-id address export workers still running the previous release open.
export const PRINT_ACTIVITY_ALIAS_PATH = '/print/activity/:activityId';
